// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-tile{background-color:#fff;border:1px solid #e2e8f0;border-radius:8px;box-shadow:none;box-sizing:border-box;display:flex;flex-direction:column;min-height:188px;padding:16px;width:100%}.header-tile .header-tile-title{color:#101828;font-size:17.5px;font-weight:400;line-height:21px;text-align:left}.header-tile .header-tile-text{color:#495057;font-size:49px;font-weight:400;line-height:56px;margin-top:24px;text-align:left}", ""]);
// Exports
module.exports = exports;
